import { toast } from 'sonner';

import { useAxios } from '@/hooks/useAxios';
import { useMy } from '@/hooks/useMy';
import { ResourceType } from '@/types';
import { useMutation } from '@/utils/api';

interface CreateAttribute {
  key: string;
  name: string;
  value: string;
}

interface DeleteAttribute {
  key: string;
}

export const useCreateAttribute = (skipToast = false) => {
  const axios = useAxios();
  const { invalidate: invalidateAttributes } = useMy(
    {
      resource: ResourceType.Attribute,
    },
    {
      enabled: false,
    }
  );

  return useMutation({
    defaultErrorMessage: `Failed to add attribute`,
    mutationFn: async (attribute: CreateAttribute) => {
      const promise = axios.put(`/attribute`, {
        key: attribute.key,
        name: attribute.name,
        value: attribute.value,
      });

      if (!skipToast) {
        toast.promise(promise, {
          loading: 'Adding attribute...',
          success: 'Attribute added',
          error: 'Failed to add attribute',
        });
      }

      const { data } = await promise;
      invalidateAttributes();

      return data;
    },
  });
};

export const useDeleteAttribute = (skipToast = false) => {
  const axios = useAxios();

  return useMutation({
    defaultErrorMessage: `Failed to delete attribute`,
    mutationFn: async (attribute: DeleteAttribute) => {
      const promise = axios.delete(`/attribute`, {
        data: {
          key: attribute.key,
        },
      });

      if (!skipToast) {
        toast.promise(promise, {
          loading: 'Deleting attribute...',
          success: 'Successfully deleted attribute',
          error: err => {
            return err?.message || 'Failed to delete attribute';
          },
        });
      }

      const { data } = await promise;
      return data;
    },
  });
};
